import {
  generateBFFUrl,
  LOCATION_LAT_LONG,
  LOCATION_PLACE_ID,
  LOCATION_SUGGESTIONS,
  REVERSE_GEO_CODE,
} from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';

export const fetchLocationFromLatLong = async (
  latitude: number,
  longitude: number,
): Promise<any> => {
  const locationDetails = await axiosInstance
    .get(generateBFFUrl(LOCATION_LAT_LONG), {
      params: {
        latitude,
        longitude,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return locationDetails;
};

export const fetchLocationSuggestions = async (input: string): Promise<any> => {
  const suggestions = await axiosInstance
    .get(generateBFFUrl(LOCATION_SUGGESTIONS), {
      params: {
        input,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return suggestions;
};

export const fetchLocationByPlaceId = async (placeId: string): Promise<any> => {
  const addressDetails = await axiosInstance
    .get(generateBFFUrl(LOCATION_PLACE_ID), {
      params: {
        place_id: placeId,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return addressDetails;
};

export const fetchLocationByReverseGeoCode = async (address: string): Promise<any> => {
  const addressDetails = await axiosInstance
    .get(generateBFFUrl(REVERSE_GEO_CODE), {
      params: {
        address,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return addressDetails;
};
